// @ts-nocheck
const MILLISECOND = 1;
const SECOND = 1000 * MILLISECOND;
const MINUTE = 60 * SECOND;

var Sift = {
  State: Object.freeze({
    UNINITIALIZED: "uninitialized", // Initial state, have not received voip token.
    AUTHENTICATING: "authenticating", // Sent authentication token, waiting for response.
    AUTHENTICATED: "authenticated", // Auth successful, ready to connect.
    RINGING: "ringing", // Incoming call is connecting.
    CONNECTING: "connecting", // Establishing a connection.
    CONNECTED: "connected", // Connected to a call.
  }),

  Error: Object.freeze({
    NONE: "none",
    UNKNOWN: "unknown",
    LOST_INTERNET: "lost-internet",
    NO_MIC: "no-mic",
    MIC_DISABLED: "mic-disabled",
    MIC_PERMISSION_DENIED: "mic-permission-denied",
    AUTHENTICATION_FAILED: "authentication-failed",
    OUTGOING_NOT_PERMITTED: "outgoing-not-permitted",
  }),

  MAX_CALL_DURATION: 30 * MINUTE,

  GRIDSPACE_VOIP_URI: "wss://api.gridspace.com/webrtc/",

  // Callback functions to be set by the client:
  onAuthenticated: null,
  onResumed: null,
  onIncomingCall: null,
  onConnected: null,
  onRemotePartyHungUp: null,
  onError: null,
  onMaxDuration: null,

  voipSupported: () => !!window.RTCPeerConnection,
  authenticate: function (token, overrideVoipUri, metadata) {
    if (this._state === this.State.CONNECTED) {
      this.hangUp();
    }

    if (!token) {
      throw "Must provide a token";
    }

    if (overrideVoipUri) {
      this.GRIDSPACE_VOIP_URI = overrideVoipUri;
    }

    this._state = this.State.AUTHENTICATING;

    // Create the audio element if needed.
    if (!document.getElementById("audio_remote")) {
      var remote_audio = document.createElement("audio");
      remote_audio.id = "audio_remote";
      remote_audio.autoplay = true;
      document.body.appendChild(remote_audio);
    }

    this._token = token;
    this._metadata = metadata || null;
    this._resumeToken = null;

    this._sock = new WebSocket(this.GRIDSPACE_VOIP_URI);
    this._sock.onopen = this._onSocketConnected.bind(this);

    this._sock.onmessage = function (event) {
      var data = JSON.parse(event.data);
      this._onSocketMessage(data);
    }.bind(this);
    this._sock.onerror = this._onSocketError.bind(this);
    this._sock.onclose = this._onSocketClose.bind(this);
  },

  connect: function (data, listenOnly) {
    if (this._state !== this.State.AUTHENTICATED || !this._token) {
      throw "Initialize before calling ready";
    }

    this._state = this.State.CONNECTING;
    this._send({ type: "connect", body: data });
    this._connect(listenOnly);
  },

  reconnect: function () {
    if (!this._resumeToken) {
      throw "No connection to resume!";
    }
    if (this._sock) {
      return;
    }

    this._sock = new WebSocket(this.GRIDSPACE_VOIP_URI);
    this._sock.onopen = function (event) {
      this._send({
        type: "resume",
        body: this._resumeToken,
      });
    }.bind(this);

    this._sock.onmessage = function (event) {
      var data = JSON.parse(event.data);
      this._onSocketMessage(data);
    }.bind(this);
    this._sock.onerror = this._onSocketError.bind(this);
    this._sock.onclose = this._onSocketClose.bind(this);
  },

  mute: function () {
    this.setMuted(true);
  },
  unmute: function () {
    this.setMuted(false);
  },
  setMuted: function (muted) {
    if (muted != this.muted) {
      this.muted = muted;

      if (!this._localMediaStream || !this._localMediaStream.getAudioTracks) {
        return;
      }
      var tracks = this._localMediaStream.getAudioTracks();
      tracks.forEach((track) => {
        track.enabled = !muted;
      });
    }
  },
  setSpeakerVolume: (volume) => {
    var remoteAudio = document.getElementById("audio_remote");
    if (remoteAudio) {
      remoteAudio.volume = volume;
    }
  },
  hangUp: function () {
    if (this._state === this.State.CONNECTED) {
      this._state = this.State.AUTHENTICATED;
      console.log("Voip: hangup");
      this._send({ type: "hangup" });
      this._disconnect();
    }

    this.muted = false;
  },
  reset: function () {
    console.log("voip: reset");
    this.hangUp();
    if (this._sock) {
      this._sock.close();
      this._sock = null;
    }
    this._token = null;
    this._state = this.State.UNINITIALIZED;
  },
  state: function () {
    return this._state;
  },

  _onVoipConnected: function (stream) {
    if (this._state == this.State.CONNECTING) {
      this._state = this.State.CONNECTED;
      this._maxDurationTimer = setTimeout(() => {
        var mins = this.MAX_CALL_DURATION / MINUTE;
        console.log("WebRTC Widget: max call duration (" + mins + " min) reached, hanging up");
        this.hangUp();
        if (this.onMaxDuration) {
          this.onMaxDuration();
        }
      }, this.MAX_CALL_DURATION);
      if (this.onConnected) {
        this.onConnected(stream);
      }
    } else {
      this._disconnect();
    }
  },

  _send: function (message) {
    if (this._sock) {
      this._sock.send(JSON.stringify(message));
    }
  },

  _onSocketConnected: function () {
    if (this._state === this.State.AUTHENTICATING) {
      var body = this._token;
      if (this._metadata) {
        body = JSON.stringify({ ...this._metadata, webrtc_code: this._token });
      }
      this._send({ type: "auth", body: body });
    }
  },

  _onSocketError: function () {
    if (this._state !== this.State.UNINITIALIZED) {
      this._sock = null;
      this._state = this.State.UNINITIALIZED;
      if (this.onError) {
        this.onError(this.Error.LOST_INTERNET);
      }
    }
  },

  _onSocketClose: function () {
    this._sock = null;
  },

  answer: function () {
    if (this._state === this.State.RINGING) {
      this._send({
        type: "ringanswer",
        body: true,
      });
      this.muted = false;
      this._state = this.State.CONNECTING;
      this._connect();
    }
  },
  decline: function () {
    if (this._state === this.State.RINGING) {
      this._send({
        type: "ringanswer",
        body: false,
      });
      this._state = this.State.AUTHENTICATED;
    }
  },

  _onSocketMessage: function (message) {
    if (message.type === "auth") {
      if (this._state === this.State.AUTHENTICATING) {
        if (message.body === "OK") {
          this._resumeToken = message.resume_token;
          this._iceServers = message.ice_servers;
          this._state = this.State.AUTHENTICATED;
          if (this.onAuthenticated) {
            this.onAuthenticated();
          }
        } else {
          this._token = null;
          this._state = this.State.UNINITIALIZED;
          if (this.onError) {
            this.onError(this.Error.AUTHENTICATION_FAILED);
          }
        }
      }
    } else if (message.type === "resume") {
      console.log("Resumed!");
      if (message.body === "OK") {
        this._state = this.State.CONNECTED;
        if (this.onResumed) {
          this.onResumed();
        }
      }
    } else if (message.type === "ring") {
      if (this._state === this.State.AUTHENTICATED) {
        this._state = this.State.RINGING;
        if (this.onIncomingCall) {
          this.onIncomingCall();
        }
      }
    } else if (message.type === "desc") {
      var desc = message.body;
      if (desc.type == "answer") {
        this._peerConnection.setRemoteDescription(
          new RTCSessionDescription(desc),
        );
      } else {
        console.log("Unsupported SDP type. Your code may differ here.");
      }
    } else if (message.type === "candidate") {
      this._peerConnection.addIceCandidate(new RTCIceCandidate(message.body));
    } else if (message.type === "hangup") {
      if (
        this._state === this.State.CONNECTED ||
        // We can receive "hangup" during CONNECTING if the expert declines a call during on_call_received.
        this._state === this.State.CONNECTING 
      ) {
        this._state = this.State.AUTHENTICATED;
        this._disconnect();
        if (this.onRemotePartyHungUp) {
          this.onRemotePartyHungUp();
        }
      }
    } else if (message.type === "transfer") {
      if (this._state === this.State.CONNECTED) {
        if (this._peerConnection) {
          this._peerConnection.close();
          this._peerConnection = null;
        }
        this._state = this.State.CONNECTING;
        this._connect();
      }
    } else if (message.type === "reset") {
      this.reset();
    } else if (message.type === "error") {
      console.error("RTC error message: ", message);
      this._state = this.State.UNINITIALIZED;
      this._disconnect();
      if (this.onError) {
        this.onError(this.Error.UNKNOWN);
      }
    } else {
      console.error("Unknown message type:", message.type);
    }
  },

  _connect: function (listenOnly) {
    const iceServers = this._iceServers || [
      { urls: ["stun:stun.l.google.com:19302", "stun:stun.sipgate.net:10000"] },
    ];
    console.log("Ice servers:", iceServers);

    var configuration = {
      iceServers: iceServers,
    };
    this._peerConnection = new RTCPeerConnection(configuration);

    this._peerConnection.onicecandidate = function (evt) {
      console.log("onicecandidate", evt);
      if (evt.candidate) {
        this._send({
          type: "candidate",
          body: evt.candidate,
        });
      }
    }.bind(this);

    this._peerConnection.onnegotiationneeded = function () {
      console.log("ON negotiationneeded");
      this._createAndSendOffer();
    }.bind(this);

    this._peerConnection.ontrack = function (evt) {
      console.log("ON REMOTE TRACK", evt);
      var remoteAudio = document.getElementById("audio_remote");
      if (evt.streams && evt.streams[0]) {
        remoteAudio.srcObject = evt.streams[0];
        remoteAudio.play().catch(function (e) {
          console.warn("Audio autoplay blocked:", e);
        });
        this._onVoipConnected(evt.streams[0]);
      }
    }.bind(this);

    if (this._localMediaStream) {
      this._localMediaStream.getAudioTracks().forEach((track) => {
        track.enabled = !this.muted;
        this._peerConnection.addTrack(track);
      });
    } else if (!listenOnly) {
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: false })
        .then(
          function (stream) {
            if (
              this._state === this.State.CONNECTING ||
              this._state === this.State.CONNECTED
            ) {
              console.log("GOT USER MEDIA");
              this._localMediaStream = stream;
              this._localMediaStream.getAudioTracks().forEach((track) => {
                track.enabled = !this.muted;
                this._peerConnection.addTrack(track);
              });
            }
          }.bind(this),
        )
        .catch(function (error) {
          console.error("Mic permission error:", error);
          this._state = this.State.UNINITIALIZED;
          this._disconnect();
          if (this.onError) {
            this.onError(this.Error.MIC_PERMISSION_DENIED);
          }
        }.bind(this));
    } else {
      const audioCtx = new AudioContext();
      const dest = audioCtx.createMediaStreamDestination();
      this._localMediaStream = dest.stream;
      this._localMediaStream.getAudioTracks().forEach((track) => {
        this._peerConnection.addTrack(track);
      });
    }
  },

  _createAndSendOffer: function () {
    console.log("Create and send offer");
    this._peerConnection
      .createOffer()
      .then(
        function (offer) {
          console.log("created offer", offer);
          return this._peerConnection.setLocalDescription(offer);
        }.bind(this),
        (error) => {
          console.log("offer failed", error);
        },
      )
      .then(
        function () {
          console.log("local description set ok");
          this._send({
            type: "desc",
            body: this._peerConnection.localDescription,
          });
        }.bind(this),
      );
  },

  _disconnect: function () {
    if (this._maxDurationTimer) {
      clearTimeout(this._maxDurationTimer);
      this._maxDurationTimer = null;
    }

    if (this._peerConnection) {
      this._peerConnection.close();
      this._peerConnection = null;
    }

    if (this._localMediaStream) {
      var tracks = this._localMediaStream.getTracks();
      for (var i = 0; i < tracks.length; ++i) {
        tracks[i].stop();
      }
      this._localMediaStream = null;
    }
  },

  _state: "uninitialized",
  _sock: null,
  _localMediaStream: null,
  _maxDurationTimer: null,
};

// For <script> tag consumers.
window.Sift = Sift;

// For js/src/webrtc-widgets/
export { Sift };
